import Drag from './Drag';
export default Drag;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Drag/index.js